import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  radioGroup: {
    marginTop: 8
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: 14
  },
  radioItemRoot: {
    "& .MuiRadio-root": {
      color: theme.palette.text.hint
    },
    "& .Mui-checked": {
      color: theme.palette.secondary.main
    },
    "& .MuiSvgIcon-root:last-child": {
      color: "#02c092"
    },
    "& .Mui-checked + .MuiTypography-root": {
      color: theme.palette.text.primary
    }
  }
}));
